import React, {useEffect, useState} from 'react';
import {useAuth} from "../../AuthContext";
import {Scrollbar} from "react-scrollbars-custom";
import "./Peak.css";

export function Peak() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [campaignerId, setCampaignerId] = useState('');
    const [price, setPrice] = useState('0.00');
    const [campaignerImo, setCampaignerImo] = useState('');
    const [priceImo, setPriceImo] = useState('0.00');
    const [campaignerViber, setCampaignerViber] = useState('');
    const [priceViber, setPriceViber] = useState('0.00');
    const [campaignerTg, setCampaignerTg] = useState('');
    const [priceTg, setPriceTg] = useState('0.00');

    const [message, setMessage] = useState(null);

    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [userCampaigns, setUserCampaigns] = useState([]);
    const [selectedCampaignId, setSelectedCampaignId] = useState(null);
    const [campaignMessages, setCampaignMessages] = useState([]);

    const [campaignerIds, setCampaignerIds] = useState([]);
    const [days, setDays] = useState([]);

    const { fetchWithAuth } = useAuth();

    const handleRegister = async () => {
        setMessage(null);
        if (!username || !password) {
            setMessage('Please fill in all fields');
            return;
        }

        const waOK = campaignerId && !isNaN(parseFloat(price));
        const imoOK = campaignerImo && !isNaN(parseFloat(priceImo));
        const viberOK = campaignerViber && !isNaN(parseFloat(priceViber));
        const tgOK = campaignerTg && !isNaN(parseFloat(priceTg));

        if (!waOK && !imoOK && !viberOK && !tgOK) {
            setMessage('Specify price and campaigner ID for at least one channel');
            return;
        }

        try {
            const res = await fetchWithAuth('/api/admin/register', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username,
                    password,
                    price_wa: isNaN(parseFloat(price)) ? 0.00 : parseFloat(price),
                    price_imo: isNaN(parseFloat(priceImo)) ? 0.00 : parseFloat(priceImo),
                    price_viber: isNaN(parseFloat(priceViber)) ? 0.00 : parseFloat(priceViber),
                    price_telegram: isNaN(parseFloat(priceTg)) ? 0.00 : parseFloat(priceTg),
                    campaigner_id: campaignerId ? parseInt(campaignerId) : null,
                    campaigner_imo: campaignerImo ? parseInt(campaignerImo) : null,
                    campaigner_viber: campaignerViber ? parseInt(campaignerViber) : null,
                    campaigner_telegram: campaignerTg ? parseInt(campaignerTg) : null
                })
            });
            const data = await res.json();
            if (res.ok) {
                setMessage('✅ User successfully created');
                setUsername('');
                setPassword('');
                setCampaignerId('');
                setCampaignerImo('');
                setCampaignerViber('');
                setCampaignerTg('');
                setPrice('0.00');
                setPriceImo('0.00');
                setPriceViber('0.00');
                setPriceTg('0.00');
            } else {
                setMessage(`❌ Error: ${data.error}`);
            }
        } catch (err) {
            setMessage('❌ Network error');
        }
    };

    const fetchUsers = async () => {
        const res = await fetchWithAuth('/api/admin/users');
        const data = await res.json();
        if (data.success) setUsers(data.users);
    };

    const fetchUserCampaigns = async (userId) => {
        setSelectedUserId(userId);
        const res = await fetchWithAuth(`/api/admin/campaigns/${userId}`);
        const data = await res.json();
        if (data.success) setUserCampaigns(data.campaigns);
    };

    const fetchCampaignMessages = async (campaignId) => {
        setSelectedCampaignId(campaignId);
        const res = await fetchWithAuth(`/api/admin/campaign/${campaignId}`);
        const data = await res.json();
        if (data.success) setCampaignMessages(data.data);
    };

    const fetchCampaignerIds = async () => {
        const res = await fetchWithAuth('/api/admin/campaignerIds');
        const data = await res.json();
        if (data.success) {
            setCampaignerIds(data.data);
            const uniqDays = [...new Set(data.data.map(r => r.day))]
                .sort((a, b) => new Date(b) - new Date(a));
            setDays(uniqDays);
        }

    };


    useEffect(() => {
        fetchUsers();
fetchCampaignerIds();
    }, []);

    const grid = campaignerIds.reduce((acc, r) => {
        const cid = r.campaigner_id;

        // если этого campaigner ещё нет — создаём контейнер
        if (!acc[cid]) {
            acc[cid] = { __usernames: r.usernames || [] };   // 👈 кладём логины сюда
        }

        // если логины пришли, а раньше были пустые — обновим
        if (r.usernames && acc[cid].__usernames.length === 0) {
            acc[cid].__usernames = r.usernames;
        }

        // сохраняем агрегаты по дате
        acc[cid][r.day] = r;
        return acc;
    }, {});

    return (
        <div className='peakPage'>
            <div className='peakContainer'>
                <div>
            <div className="labelP">
                Create user
            </div>
            <input className="paymentWidgetAddNumber" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} /><br /><br />
            <input className="paymentWidgetAddNumber" placeholder="Password" type="password" value={password} onChange={e => setPassword(e.target.value)} /><br /><br />
            <input className="paymentWidgetAddNumber" placeholder="Campaigner WA" value={campaignerId} onChange={e => setCampaignerId(e.target.value)} /><br /><br />
            <input className="paymentWidgetAddNumber" placeholder="WA price" value={price} onChange={e => setPrice(e.target.value)} /><br /><br />
            <input className="paymentWidgetAddNumber" placeholder="Campaigner Imo" value={campaignerImo} onChange={e => setCampaignerImo(e.target.value)} /><br /><br />
            <input className="paymentWidgetAddNumber" placeholder="Imo price" value={priceImo} onChange={e => setPriceImo(e.target.value)} /><br /><br />
            <input className="paymentWidgetAddNumber" placeholder="Campaigner Viber" value={campaignerViber} onChange={e => setCampaignerViber(e.target.value)} /><br /><br />
            <input className="paymentWidgetAddNumber" placeholder="Viber price" value={priceViber} onChange={e => setPriceViber(e.target.value)} /><br /><br />
            <input className="paymentWidgetAddNumber" placeholder="Campaigner Tg" value={campaignerTg} onChange={e => setCampaignerTg(e.target.value)} /><br /><br />
            <input className="paymentWidgetAddNumber" placeholder="Tg price" value={priceTg} onChange={e => setPriceTg(e.target.value)} /><br /><br />
            <button onClick={handleRegister} className="addBalanceButton"><div className="addBalanceButtonText">Create user</div></button>

            {message && <div style={{ marginTop: 10 }}>{message}</div>}
                </div>

                <div style={{ marginTop: 40, width: '100%' }}>
            <div className="labelP">
                User list
            </div>
            <Scrollbar
                style={{width: '100%', height: '200px', overflowX: 'auto', marginTop: '16px'}}
                thumbYProps={{style: {background: '#268DFF',},}}
                thumbXProps={{style: {background: '#268DFF',},}}
            >
                <table
                    className="blockAllLinksTable"
                >
                    <thead>
                    <tr>
                        <th className="blockAllLinksTableHeadRowElement">#</th>
                        <th className="blockAllLinksTableHeadRowElement">Username</th>
                        <th className="blockAllLinksTableHeadRowElement">Registration Date</th>
                        <th className="blockAllLinksTableHeadRowElement">Balance</th>
                        <th className="blockAllLinksTableHeadRowElement">CampaignerWA</th>
                        <th className="blockAllLinksTableHeadRowElement">PriceWA</th>
                        <th className="blockAllLinksTableHeadRowElement">CampaignerImo</th>
                        <th className="blockAllLinksTableHeadRowElement">PriceImo</th>
                        <th className="blockAllLinksTableHeadRowElement">CampaignerV</th>
                        <th className="blockAllLinksTableHeadRowElement">PriceV</th>
                        <th className="blockAllLinksTableHeadRowElement">CampaignerTG</th>
                        <th className="blockAllLinksTableHeadRowElement">PriceTG</th>
                        <th className="blockAllLinksTableHeadRowElement">Campaigns Amount</th>
                        <th className="blockAllLinksTableHeadRowElement">Last Campaign</th>
                    </tr>
                    </thead>
                    <tbody>
                    {users.map((s) => (
                        <tr key={s.id} onClick={() => fetchUserCampaigns(s.id)} style={{ cursor: 'pointer' }}>
                            <td className="blockAllLinksTableDRowElement">{s.id}</td>
                            <td className="blockAllLinksTableDRowElement">{s.username}</td>
                            <td className="blockAllLinksTableDRowElement">{new Date(s.created_at).toLocaleDateString()}</td>
                            <td className="blockAllLinksTableDRowElement">${s.balance}</td>
                            <td className="blockAllLinksTableDRowElement">{s.campaigner_id}</td>
                            <td className="blockAllLinksTableDRowElement">{s.price_wa}</td>
                            <td className="blockAllLinksTableDRowElement">{s.campaigner_imo}</td>
                            <td className="blockAllLinksTableDRowElement">{s.price_imo}</td>
                            <td className="blockAllLinksTableDRowElement">{s.campaigner_viber}</td>
                            <td className="blockAllLinksTableDRowElement">{s.price_viber}</td>
                            <td className="blockAllLinksTableDRowElement">{s.campaigner_telegram}</td>
                            <td className="blockAllLinksTableDRowElement">{s.price_telegram}</td>
                            <td className="blockAllLinksTableDRowElement">{s.campaign_count}</td>
                            <td className="blockAllLinksTableDRowElement">{s.last_campaign_date ? new Date(s.last_campaign_date).toLocaleString() : '-'}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </Scrollbar>
                </div>

            {selectedUserId && userCampaigns.length > 0 && (
                <div style={{ marginTop: 40, width: '100%' }}>
                    <div className="labelP">
                        User campaigns #{selectedUserId}
                    </div>
                    <Scrollbar
                        style={{width: '100%', height: '400px', overflowX: 'auto', marginTop: '16px'}}
                        thumbYProps={{style: {background: '#268DFF',},}}
                        thumbXProps={{style: {background: '#268DFF',},}}
                    >
                        <table
                            className="blockAllLinksTable"
                        >
                            <thead>
                            <tr>
                                <th style={{width: '100px'}} className="blockAllLinksTableHeadRowElement">ID</th>
                                <th className="blockAllLinksTableHeadRowElement">Name</th>
                                <th className="blockAllLinksTableHeadRowElement">Message</th>
                                <th className="blockAllLinksTableHeadRowElement">Created At</th>
                                <th className="blockAllLinksTableHeadRowElement">Type</th>
                                <th className="blockAllLinksTableHeadRowElement">Messages Amount</th>
                                <th className="blockAllLinksTableHeadRowElement">Pending</th>
                                <th className="blockAllLinksTableHeadRowElement">Sent</th>
                                <th className="blockAllLinksTableHeadRowElement">Delivered</th>
                                <th className="blockAllLinksTableHeadRowElement">Failed</th>
				<th className="blockAllLinksTableHeadRowElement">Undelivered</th>
                            </tr>
                            </thead>
                            <tbody>
                            {userCampaigns.map((m) => (
                                <tr key={m.id} onClick={() => fetchCampaignMessages(m.id)} style={{ cursor: 'pointer' }}>
                                    <td className="blockAllLinksTableDRowElement">{m.id}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.name}</td>
                                    <td title={m.message} className="blockAllLinksTableDRowElement">{m.message.slice(0, 30)}...</td>
                                    <td className="blockAllLinksTableDRowElement">{new Date(m.created_at).toLocaleString()}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.channel}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.total}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.pending}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.sent}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.delivered}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.failed}</td>
				<td className="blockAllLinksTableDRowElement">{m.undelivered}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </Scrollbar>
                </div>
            )}

            {selectedCampaignId && campaignMessages.length > 0 && (
                <div style={{ marginTop: 40, width: '100%' }}>
                    <div className="labelP">
                        Campaign messages #{selectedCampaignId}
                    </div>
                    <Scrollbar
                        style={{width: '100%', height: '400px', overflowX: 'auto', marginTop: '16px'}}
                        thumbYProps={{style: {background: '#268DFF',},}}
                        thumbXProps={{style: {background: '#268DFF',},}}
                    >
                        <table
                            className="blockAllLinksTable"
                        >
                            <thead>
                            <tr>
                                <th style={{width: '100px'}} className="blockAllLinksTableHeadRowElement">ID</th>
                                <th className="blockAllLinksTableHeadRowElement">Phone Number</th>
                                <th className="blockAllLinksTableHeadRowElement">Field 1</th>
                                <th className="blockAllLinksTableHeadRowElement">Field 2</th>
                                <th className="blockAllLinksTableHeadRowElement">Field 3</th>
                                <th className="blockAllLinksTableHeadRowElement">Status</th>
                                <th className="blockAllLinksTableHeadRowElement">Price</th>
                                <th className="blockAllLinksTableHeadRowElement">Created At</th>
                                <th className="blockAllLinksTableHeadRowElement">Updated At</th>
                            </tr>
                            </thead>
                            <tbody>
                            {campaignMessages.map((m) => (
                                <tr key={m.id}>
                                    <td className="blockAllLinksTableDRowElement">{m.id}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.dst_addr}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.field_1}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.field_2}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.field_3}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.status}</td>
                                    <td className="blockAllLinksTableDRowElement">{m.price}</td>
                                    <td className="blockAllLinksTableDRowElement">{new Date(m.created_at).toLocaleString()}</td>
                                    <td className="blockAllLinksTableDRowElement">{new Date(m.status_updated_at).toLocaleString()}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </Scrollbar>
                </div>
            )}
                <Scrollbar
                    style={{ width: '100%', height: 350, overflowX: 'auto', marginTop: 16 }}
                    thumbYProps={{ style: { background: '#268DFF' } }}
                    thumbXProps={{ style: { background: '#268DFF' } }}
                >
                    <table className="blockAllLinksTable">
                        <thead>
                        <tr>
                            <th className="blockAllLinksTableHeadRowElement">Campaigner ID / Users</th>
                            {days.map(d => (
                                <th key={d} className="blockAllLinksTableHeadRowElement">
                                    {new Date(d).toLocaleDateString()}
                                </th>
                            ))}
                        </tr>
                        </thead>

                        <tbody>
                        {Object.entries(grid).map(([cid, dayMap]) => (
                            <tr key={cid}>
                                {/*‑‑‑ левая колонка с campaigner_id и логинами ‑‑‑*/}
                                <td className="blockAllLinksTableDRowElement">
                                    <strong>{cid}</strong>
                                    {dayMap.__usernames?.length ? (
                                        <div style={{ fontSize: 11, color: '#555', marginTop: 4 }}>
                                            {dayMap.__usernames.join(', ')}
                                        </div>
                                    ) : null}
                                </td>

                                {/*‑‑‑ данные по каждому дню ‑‑‑*/}
                                {days.map(d => {
                                    const rec = dayMap[d];
                                    return (
                                        <td key={d} className="blockAllLinksTableDRowElement">
                                            {rec ? (
                                                <>
                                                    T:&nbsp;{rec.total}<br />
                                                    s:&nbsp;{rec.sent_cnt}<br />
                                                    d:&nbsp;{rec.delivered_cnt}<br />
                                                    f:&nbsp;{rec.failed_cnt}<br />
                                                    u:&nbsp;{rec.undelivered_cnt}
                                                </>
                                            ) : (
                                                '—'
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </Scrollbar>
            </div>
        </div>
    );
};
